<ng-container>
  <ion-icon name="attach" color="success" />
  <a href="#" (click)="openDocument($event)">{{ fileName }}</a>
  <a #downloadLink class="hidden-anchor"></a>
</ng-container>
